import { areLocationScopesEqual } from './locationScopes';

export function locationStatusKey(scope) {
  return JSON.stringify(['country', 'state', 'city', 'churchName'].map((key) => String(scope?.[key] || '')
    .normalize('NFKC').replace(/\u00a0/g, ' ').trim().replace(/\s+/g, ' ').toLocaleLowerCase()));
}

export function getSelectedLocationStatusChanges(locations, drafts) {
  const changes = new Map();
  for (const location of locations) {
    const key = locationStatusKey(location);
    if (drafts[key]) changes.set(key, { locationScope: location, status: drafts[key] });
  }
  return [...changes.values()];
}

// User data must be persisted before the status records its current fingerprint.
export async function saveUserWithLocationStatuses({ saveUser, changes, updateStatus }) {
  const savedUser = await saveUser();
  if (!savedUser?.success) return { userSaved: false, saved: [], failed: [], skipped: [] };
  const saved = [];
  const failed = [];
  const skipped = [];
  for (const change of changes) {
    const location = savedUser.locations.find((scope) => areLocationScopesEqual(scope, change.locationScope));
    if (!location) {
      skipped.push(change);
      continue;
    }
    try {
      saved.push({ change, result: await updateStatus(location, change.status) });
    } catch (error) {
      failed.push({ change, error });
    }
  }
  return { userSaved: true, saved, failed, skipped };
}
